var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-profile__summary"},[_c('div',{staticClass:"c-quote"},[_vm._v(" "+_vm._s(_vm.translate(_vm.thingsToTranslate.quote))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }